import { render } from "./subpartABD.vue?vue&type=template&id=5de8de44&scoped=true"
import script from "./subpartABD.vue?vue&type=script&lang=js"
export * from "./subpartABD.vue?vue&type=script&lang=js"

import "./subpartABD.vue?vue&type=style&index=0&id=5de8de44&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de8de44"]])

export default __exports__